import { render, staticRenderFns } from "./SearchprofilePage.vue?vue&type=template&id=df4e6132&scoped=true"
import script from "./SearchprofilePage.vue?vue&type=script&lang=js"
export * from "./SearchprofilePage.vue?vue&type=script&lang=js"
import style0 from "./SearchprofilePage.vue?vue&type=style&index=0&id=df4e6132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4e6132",
  null
  
)

export default component.exports